<template>
  <button class="d2-list-act-btn" :class="type" @click="action">
    <i class="fas fa-pen" v-if="type === 'edit'"></i>
    <i class="fas fa-chart-line" v-if="type === 'chart'"></i>
    <i class="fas fa-pause" v-if="type === 'pause'"></i>
    <i class="fas fa-paper-plane" v-if="type === 'publish'"></i>
    <i class="fas fa-trash-alt" v-if="type === 'delete'"></i>
    <i class="fas fa-play" v-if="type === 'play'"></i>
    <i class="fas fa-eye" v-if="type === 'browse'"></i>
    <i class="fas fa-paper-plane" v-if="type === 'release'"></i>
    <i class="fas fa-copy" v-if="type === 'copy'"></i>
  </button>
</template>

<script>

export default {
  name: 'ActionIcon',
  props: {
    type: {
      type: String,
      default: 'edit'
    }
  },
  methods: {
    action() {
      this.$emit('action')
    }
  }
}

</script>

<style lang="scss" scoped>

/* 樣式已由 d2-list-act-btn 全局 CSS 處理 */

</style>
